import { Component, Input } from '@angular/core';

@Component({
	selector: 'wizard-view',
	templateUrl: './wizard-view.component.html',
	styleUrls: ['./wizard-view.component.scss'],
	standalone: false
})
export class WizardViewComponent {
	@Input() public title?: string; // Translated Text

	public get hasTitle (): boolean {
		return !!this.title?.length;
	}
}
